import React, {useRef, useState} from "react";
import {
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  //FormText,
} from "reactstrap";
import UploadImg from "./UploadImg";

export default function ZaResponse({ display, setDisplay, description, itemData, setTriger, newOfferResetFormTriger }) {
  const [img1Url, setImg1Url] = useState([])
  const form = useRef(null)
  const submitHandler = async (e) => {
    e.preventDefault();
    //console.log(e)
    //const form = document.getElementById('responseForm');
    const formData = new FormData(form.current);
    console.log(formData)
    console.log(Object.fromEntries(formData))
    const dataForPost = Object.fromEntries(formData);
    console.log(dataForPost)
    const imgUrls = []
    for (var key in dataForPost) {
      if (key.includes('http')) {
        imgUrls.push(key)
      }
    }
    console.log('imgUrlssssssssss' , imgUrls)
    try {
      const response = await fetch(`api/v1/WatchHunter/wishes/${itemData.wishesId}/wish/${itemData.gid}/offer`, {
        method: "POST",
        headers: new Headers({ "Content-Type": "application/json" }),
        body: JSON.stringify({
          description: dataForPost.OfferDescription,
          Digits: dataForPost.digit,
          PriceSale: dataForPost.price,
          PriceMinimum: dataForPost.minPrice,
          PhotoURLs: imgUrls,
          ExternalURL: dataForPost.OfferExtraDescription,
          ItemContains: dataForPost.contains
      }),
      });
      if (response.ok) {
        console.log(response);
        const payload = await response.json();
        form.current.reset();
        setTriger(prevState => !prevState)
      }
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (err) {
      console.error(err);
      // Handle errors here
    } finally {
      console.log("FINALLY");
    }
  }
  return (
    <div
      style={display ? {} : { display: "none" }}
      className="container wishResponses pb-5"
    >
      <div className="d-flex justify-content-between align-items-baseline mt-2">
        <h3 className="mb-3">For: {description}</h3>
        <Button
          outline
          color="dark"
          onClick={() => {
            setDisplay(false);
          }}
        >
          X
        </Button>
      </div>

      <div>
        <form 
        id="responseForm" 
        ref={form} onSubmit={submitHandler}
        >
          <FormGroup row>
            <Label for="exampleOfferDescription" sm={2}>
              Offer Description
            </Label>
            <Col sm={10}>
              <Input
                type="textarea"
                name="OfferDescription"
                id="exampleOfferDescription"
                placeholder="Descrption of offer placeholder"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="exampleOfferExtraDescription" sm={2}>
              Offer details link
            </Label>
            <Col sm={10}>
              <Input
                type="url"
                name="OfferExtraDescription"
                id="exampleOfferExtraDescription"
                placeholder="If there is a url for the offer, write it here"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="digit" sm={2}>
              Digit
            </Label>
            <Col sm={10}>
              <Input
                type="text"
                name="digit"
                id="digit"
                placeholder="digit"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="price" sm={2}>
              Price{" "}
            </Label>
            <Col sm={10}>
              <Input
                type="number"
                name="price"
                id="examplePrice"
                placeholder="12581"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="minPrice" sm={2}>
              Min Price
            </Label>
            <Col sm={10}>
              <Input
                type="number"
                name="minPrice"
                id="exampleMinPrice"
                placeholder="12000"
              />
            </Col>
          </FormGroup>
          <FormGroup row className="d-none">
            <Label for="exampleText" sm={2}>
              Text Area
            </Label>
            <Col sm={10}>
              <Input type="textarea" name="text" id="exampleText" />
            </Col>
          </FormGroup>
          <FormGroup tag="fieldset" row>
            <legend className="col-form-label col-sm-2">Item contains: </legend>
            <Col sm={10}>
              <FormGroup check>
                <Label check>
                  <Input type="radio" name="contains" value='Watch'/> Watch only
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input type="radio" name="contains" value='Watch + Box'/> Watch + Box
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input type="radio" name="contains" value='Watch + Paper'/> Watch + Paper
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input type="radio" name="contains" value='Watch + Paper + Box'/> Watch + Paper + Box
                </Label>
              </FormGroup>
            </Col>
          </FormGroup>
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <UploadImg display={display} setImg1Url={setImg1Url} img1Url={img1Url} newOfferResetFormTriger={newOfferResetFormTriger}/>
            <UploadImg display={display} setImg1Url={setImg1Url} img1Url={img1Url} newOfferResetFormTriger={newOfferResetFormTriger}/>
            <UploadImg display={display} setImg1Url={setImg1Url} img1Url={img1Url} newOfferResetFormTriger={newOfferResetFormTriger}/>
          </div>
          <FormGroup check row>
            <Col sm={{ size: 12, offset: 0 }}>
              <Button>Submit</Button>
            </Col>
          </FormGroup>
        </form>
      </div>
    </div>
  );
}
